// Module
var code = "<svg viewBox=\"0 0 16 12\"> <circle cx=\"50%\" cy=\"50%\" r=\"4\"/> </svg> ";
// Exports
module.exports = code;